import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionariosComponent } from './questionarios.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { QuestionariosRoutingModule } from './questionarios-routing.module';
import { AddNewQuestionarioComponent } from './components/add-new-questionario/add-new-questionario.component';
import { EditQuestionariosComponent } from './components/edit-questionarios/edit-questionarios.component';
import { ListQuestionariosComponent } from './components/list-questionarios/list-questionarios.component';
import { StatusQuestionarioComponent } from './components/status-questionario/status-questionario.component';
import { AddCategoriaComponent } from './components/add-categoria/add-categoria.component';
import { ListCategoriaComponent } from './components/list-categoria/list-categoria.component';
import { EditCategoriaComponent } from './components/edit-categoria/edit-categoria.component';
import { MatRadioModule } from '@angular/material/radio';
import { IdadesMinMaxComponent } from './components/idades-min-max/idades-min-max.component';

const components =
  [QuestionariosComponent,
    AddNewQuestionarioComponent,
    AddCategoriaComponent,
    EditQuestionariosComponent,
    EditCategoriaComponent,
    ListQuestionariosComponent,
    ListCategoriaComponent,
    StatusQuestionarioComponent,
    IdadesMinMaxComponent,
  ]

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    QuestionariosRoutingModule,
    SharedModule,
    MatMenuModule,
    MatIconModule,
    MatRadioModule,
  ],
  declarations: [
    ...components
  ]
})
export class QuestionariosModule { }
